export type DeliverFileInput = {
  url: string;
  filename: string;
  openInTab: boolean;
};

export const deliverFile = ({ url, filename, openInTab }: DeliverFileInput): void => {
  if (openInTab && window.open(url, "_blank")) return;

  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
};
